import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpApiService } from '../http.api.service';

@Injectable({
  providedIn: 'root'
})
export class EfateCakeRunApiService extends HttpApiService {
  override apiUrl: string = environment.BAMS_Api_URL;

  startCAKE(efateSetupPk: number): Observable<any> {
    const endpoint = `api/efate/runCAKE/start/${efateSetupPk}`;
    return this.get(endpoint).pipe(map((data: any) => data?.Value ?? data));
  }

  getCAKEStatus(efateSetupPk: number): Observable<any> {
    const endpoint = `api/efate/runCAKE/status/${efateSetupPk}`;
    return this.get(endpoint).pipe(map((data: any) => data?.Value ?? data));
  }
}
